/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressApiModel } from './addressApiModel';


export interface CompanyApiModel { 
    id: number;
    tenantId: number;
    name: string;
    inlineAddress: string;
    ico: string;
    dic: string;
    icDPH: string;
    address: AddressApiModel;
    alias: string;
    isMain: boolean;
}

